import { Component, Input } from '@angular/core';



@Component({
  selector: 'app-guage',
  templateUrl: './guage.component.html',
  styleUrl: './guage.component.css',
})
export class GuageComponent{

  @Input()
  gaugeValue: any =0;

  @Input()
  gaugeLabel = "";

  @Input()
  gaugeAppendText = "";

  @Input()
  min=0

  @Input()
  max=1000

  @Input()
  thresholds={}

  thresholdConfig = {
    '100': {color: 'red'},
    '499': {color: 'orange'},
    '699': {color: 'green'}
};

}
